import type { ReactNode } from 'react';
import { useMemo } from 'react';

import { addATrip } from './addATrip.slice';
import {
  PricingFormProvider,
  type PricingFormContextValue,
} from './Pricing/PricingFormContext';
import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';

export function AddATripPricingFormProvider({
  children,
}: {
  children: ReactNode;
}) {
  const dispatch = useAppDispatch();
  const selectedPassenger = useAppSelector(
    (state) => state.addATrip.selectedPassenger
  );
  const selectedTrip = useAppSelector((state) => state.addATrip.selectedTrip);
  const selectedPayer = useAppSelector((state) => state.addATrip.selectedPayer);

  const value = useMemo<PricingFormContextValue>(
    () => ({
      selectedPassenger,
      isEditing: !!selectedTrip?.id,
      hasIntermediary: Boolean(selectedTrip?.intermediary),
      savedPassengerId: selectedTrip?.passenger.id,
      savedPayerId: selectedTrip?.payer.id,
      selectedPayer,
      onPayerSelected: (payer) => dispatch(addATrip.actions.selectPayer(payer)),
    }),
    [selectedPassenger, selectedTrip, selectedPayer, dispatch]
  );

  return <PricingFormProvider value={value}>{children}</PricingFormProvider>;
}
